export default "__VITE_ASSET__gfJcJX69__"